"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelEdit = exports.FormModel = exports.FormModelMutator = void 0;
var tslib_1 = require("tslib");
var id_1 = require("../../id");
var form_metadata_1 = require("./form.metadata");
var form_state_1 = require("./form.state");
var form_subform_1 = require("./form.subform");
var FormModelMutator = /** @class */ (function (_super) {
    tslib_1.__extends(FormModelMutator, _super);
    function FormModelMutator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormModelMutator.prototype.displayName = function (displayName) {
        this.state.setDisplayName(displayName);
    };
    FormModelMutator.prototype.description = function (description) {
        this.state.setDescription(description);
    };
    return FormModelMutator;
}(form_subform_1.FormModelMutatorSubForm));
exports.FormModelMutator = FormModelMutator;
var FormModel = /** @class */ (function (_super) {
    tslib_1.__extends(FormModel, _super);
    function FormModel() {
        var _this = _super.call(this, null, null) || this;
        _this._state = new form_state_1.FormModelState(_this);
        _this.revision = id_1.IkeId.generate();
        _this.version = _this.revision;
        _this.rootFormId = _this.revision;
        _this.metadata = new form_metadata_1.FormModelMetadata(_this);
        return _this;
    }
    Object.defineProperty(FormModel.prototype, "state", {
        get: function () {
            return this._state = this._state || new form_state_1.FormModelState(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModel.prototype, "Mutator", {
        get: function () {
            if (this._FMutator == null) {
                this._FMutator = new FormModelMutator(this);
            }
            return this._FMutator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModel.prototype, "id", {
        get: function () { return this.state.id; },
        set: function (v) { this.state.id = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModel.prototype, "revision", {
        get: function () { return this.state.revision; },
        set: function (v) { this.state.revision = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModel.prototype, "version", {
        get: function () { return this.state.version; },
        set: function (v) { this.state.version = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModel.prototype, "rootFormId", {
        get: function () { return this.state.rootFormId; },
        set: function (v) { this.state.rootFormId = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModel.prototype, "name", {
        get: function () { return this.state.name; },
        set: function (v) { this.state.name = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModel.prototype, "description", {
        get: function () { return this.state.description; },
        set: function (v) { this.state.description = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModel.prototype, "displayName", {
        get: function () { return this.state.displayName; },
        set: function (v) { this.state.displayName = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModel.prototype, "displayVersion", {
        get: function () { return this._displayVersion; },
        set: function (v) { this._displayVersion = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModel.prototype, "updatedAt", {
        get: function () { return this.state.updatedAt; },
        set: function (v) { this.state.updatedAt = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModel.prototype, "createdAt", {
        get: function () { return this.state.createdAt; },
        set: function (v) { this.state.createdAt = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModel.prototype, "updatedBy", {
        get: function () { return this.state.updatedBy; },
        set: function (v) { this.state.updatedBy = v; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModel.prototype, "metadata", {
        get: function () { return this.state.metadata; },
        set: function (v) { this.state.metadata = v; },
        enumerable: false,
        configurable: true
    });
    FormModel.prototype.getForm = function () {
        return this;
    };
    Object.defineProperty(FormModel.prototype, "stateValue", {
        get: function () {
            var fieldState = this.state.getFieldValue(this.fieldId) || { fields: [] };
            return {
                id: this.id,
                displayName: this.state.displayName,
                fields: fieldState.fields,
                label: null,
                type: 'form'
            };
        },
        enumerable: false,
        configurable: true
    });
    return FormModel;
}(form_subform_1.FormModelFieldSubForm));
exports.FormModel = FormModel;
var FormModelEdit = /** @class */ (function (_super) {
    tslib_1.__extends(FormModelEdit, _super);
    function FormModelEdit(form, state) {
        var _this = _super.call(this) || this;
        _this.formModel = form;
        _this.revision = form.revision;
        _this._state = state;
        return _this;
    }
    return FormModelEdit;
}(FormModel));
exports.FormModelEdit = FormModelEdit;
//# sourceMappingURL=form.js.map